module.exports = __webpack_public_path__ + "img/Feature.2ffe73c6.jpg";